export function mergeUserIntoRoom(room, user) {
  if (!room || !user?.id) return room

  let changed = false

  const nextHost = room.host?.id === user.id
    ? mergeIfChanged(room.host, {
        display_name: user.display_name
      }, () => { changed = true })
    : room.host

  const nextMembers = Array.isArray(room.members)
    ? room.members.map((member) => {
        if (member?.id !== user.id) return member

        return mergeIfChanged(member, {
          display_name: user.display_name,
          avatar_url: user.avatar_url || null,
          gender: user.gender,
          bio: user.bio,
          languages: user.languages
        }, () => { changed = true })
      })
    : room.members

  return changed ? { ...room, host: nextHost, members: nextMembers } : room
}

export function mergeUserIntoMessages(messages, user) {
  if (!Array.isArray(messages) || !user?.id) return messages

  let changed = false

  const nextMessages = messages.map((message) => {
    if (message?.sender?.id !== user.id) return message

    const nextSender = mergeIfChanged(message.sender, {
      display_name: user.display_name,
      avatar_url: user.avatar_url || null
    }, () => { changed = true })

    return nextSender === message.sender ? message : { ...message, sender: nextSender }
  })

  return changed ? nextMessages : messages
}

function mergeIfChanged(current, updates, onChange) {
  let next = current

  Object.entries(updates).forEach(([key, value]) => {
    if (value === undefined || current?.[key] === value) return
    if (next === current) next = { ...current }
    next[key] = value
  })

  if (next !== current) onChange?.()
  return next
}
